<div class="idle-image-container">
    <div class="idle-image">
        <span style="font-size: 24px; font-weight: 300; margin-top: 100px;">Waiting for lead presentation</span>
        <output [hidden]="!updates.updateAvailable()" class="update-notice">
            A new Lead UI version is ready. Refresh before your next call.
            <button type="button" (click)="updates.refreshNow()">Refresh now</button>
        </output>
    </div>
</div>
